import { Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import type { PredictionMyResult } from '../../../../model/PredictionEntry';
import { MyResultCard } from './MyResultCard';

const slideClassName =
  'select-none px-2 max-md-msq:px-1 first:pl-0 last:pr-0 md-msq:w-[302px] xl-msq:w-[194px] 3xl-msq:w-[216px]';

interface PredictionMyResultsCardsProps {
  data: PredictionMyResult[];
  isLoading: boolean;
}

export const PredictionMyResultsCards = ({ data, isLoading }: PredictionMyResultsCardsProps) => (
  <>
    <div className="hidden xl-msq:flex justify-between gap-4 w-full">
      {data.map((item) => (
        <MyResultCard key={item.id} label={item.label} value={item.value} isLoading={isLoading} />
      ))}
    </div>
    <Swiper
      className="line-swiper-pagination xl-msq:hidden md-msq:-mr-[16px] sm-msq:-mr-[8px] max-w-[100vw] w-full ml-0"
      data-qa="prediction_my_result_card"
      modules={[Pagination]}
      pagination={{
        enabled: true,
        clickable: true,
      }}
      spaceBetween={8}
      breakpoints={{
        768: {
          slidesOffsetAfter: 16,
        },
        568: {
          slidesOffsetAfter: 32,
        },
      }}
      slidesPerView="auto"
    >
      {data.map((item) => {
        return (
          item && (
            <SwiperSlide key={item.id} className={slideClassName}>
              <MyResultCard
                key={item.id}
                label={item.label}
                value={item.value}
                isLoading={isLoading}
              />
            </SwiperSlide>
          )
        );
      })}
    </Swiper>
  </>
);
